/**
 * Stock Status - Standalone page wrapping StockStatusReport
 * Moved from Reports/Analytics to Inventory section
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import StockStatusReport from '../Reports/StockStatusReport';

const StockStatus: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 'var(--content-max-width)' }}>
      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{
            fontSize: 'var(--text-xl)',
            fontWeight: 600,
            color: 'var(--color-text-primary)',
            fontFamily: 'var(--font-heading)',
          }}
        >
          Stock Status
        </Typography>
        <Typography
          sx={{
            fontSize: 'var(--text-base)',
            color: 'var(--color-text-muted)',
            mt: 0.5,
          }}
        >
          Real-time stock status across all stores and warehouses with filtering by status, category, and location.
        </Typography>
      </Box>
      <StockStatusReport />
    </Box>
  );
};

export default StockStatus;
